$(function () {
    var $modal = $('#imageCropModal');
    var image = document.getElementById('sample_image');
    var cropper;
    var cropSettings = {};
    var settings;
    var cropToken;
    var inputName;

    $(document).on("change", 'input[type="file"].cropImage', function (event) {
        var btn = '<button type="button" class="btn btn-secondary cropBtn"><i class="fa fa-crop"></i> Crop</button>';
        $(this).closest(".input-group").find(".cropBtn").remove();
        $(this).closest(".input-group").append(btn)
    });

    $(document).on("click", ".cropBtn", function () {
        var parent = $(this).closest("div.input-group");
        var input = parent.find("input[type=\"file\"]");

        inputName = input.attr("name");

        // settings = input.data("settings");
        settings = {};
        var files = input.prop("files");

        cropToken = input.attr("data-cropToken");

        var dimension = $("select[name=\"" + input.attr("data-dimensionSelect") + "\"] option:selected").val();

        settings.dimension = dimension;

        $.ajax({
            url: APPLICATION + "/service/allgroups/get_image_dimension?id=" + dimension,
            dataType: 'json',
            async: false
        }).done(function (data) {
            cropSettings = {};

            var res = data.data;
            if (data.code === 200) {
                switch (res.method) {
                    case 'resize':
                        if (res.width > 0 && res.height > 0) {
                            cropSettings.aspectRatio = res.width / res.height;
                            cropSettings.cropBoxResizable = false;
                        } else {
                            cropSettings.cropBoxResizable = true;
                            cropSettings.minCropBoxWidth = res.width;
                            cropSettings.minCropBoxHeight = res.height;
                        }
                        break;
                    default:
                        cropSettings.cropBoxResizable = true;
                        cropSettings.aspectRatio = res.width / res.height;
                        cropSettings.minCropBoxWidth = res.width;
                        cropSettings.minCropBoxHeight = res.height;
                        break;
                }
            }
        })

        var done = function (url) {
            image.src = url;
            $modal.modal('show');
        };

        if (files && files.length > 0) {
            settings.image_name = files[0].name;
            settings.image_type = files[0].type;
            settings.imageFile = files[0];
            var reader = new FileReader();
            reader.onload = function (event) {
                var img = new Image();

                img.onload = function () {
                    var viewPortHeight = window.innerHeight;
                    if (img.height>img.width && img.height>600){
                        var maxHeight = viewPortHeight-370;
                        if (img.height<maxHeight) maxHeight = img.height;
                        $("#cropperImageContainer").css({"max-height": maxHeight+"px", width: maxHeight*(img.width/img.height), "max-width": "100%"});
                    } else {
                        $("#cropperImageContainer").css({width: img.width+"px", "max-width": "100%"});
                    }
                    done(reader.result);
                };

                img.src = reader.result;
            };
            reader.readAsDataURL(files[0]);
        }
    })

    $modal.on('shown.bs.modal', function () {
        cropper = new Cropper(image, {
            aspectRatio: cropSettings.aspectRatio,
            viewMode: 1,
            preview: '.preview',
            autoCropArea: 1,
            movable: false,
            zoomable: false,
            zoomOnWheel: false,
            //minContainerWidth: 840,
            cropBoxResizable: cropSettings.cropBoxResizable,
            minCropBoxWidth: cropSettings.minCropBoxWidth,
            minCropBoxHeight: cropSettings.minCropBoxHeight
        });
    }).on('hidden.bs.modal', function () {
        cropper.destroy();
        cropper = null;
    });

    $('#crop').click(function () {
        $(this).css("opacity", "0.5").css("pointer-events", "none");
        var setFillColor = settings.image_type == "image/jpeg" ? '#fff' : 'transparent'
        var canvas = cropper.getCroppedCanvas({
            fillColor: setFillColor,
            minWidth: cropSettings.minCropBoxWidth,
            minHeight: cropSettings.minCropBoxWidth,
            imageSmoothingEnabled: true,
            imageSmoothingQuality: 'high'
        });

        canvas.toBlob(function (blob) {
            $.ajax({
                url: APPLICATION + '/service/allgroups/crop_upload_client?type=' + blob.type + '&settings=' + JSON.stringify(settings)+"&"+cropToken,
                method: 'POST',
                timeout: 15000,
                processData: false,
                contentType: 'application/octet-stream',
                data: blob,
                success: function (data) {
                    $('input[name="' + inputName + '"]').val('').closest("form").submit();
                },
            });
        }, settings.image_type, 1);
    });
})
